import {
  TextField,
  DateField,
} from 'react-admin'
import {
  Typography,
} from '@material-ui/core'
import {
  NumberField,
  DatagridWithSubtotals,
} from '../../custom'
import {
  useHourlyInvoiceTickets,
  useLabel,
  useTranslateResource,
} from '../../../hooks'
import {
  currencyFieldOptions,
  numberFieldOptions,
  dateFieldOptions,
} from '../../util/component-options'
import { Invoice, DataTable} from '../../shared'

const TicketsGrid = props => {
  const resource = 'invoice_hourly_tickets'
  const { tickets } = props
  const label = useLabel({ resource })
  const groupedTickets = useHourlyInvoiceTickets(tickets)

  return (
    <DatagridWithSubtotals data={groupedTickets}>
      <DateField source='worked_at_date' label={label('worked_at_date')} options={dateFieldOptions} sortable={false} />
      <TextField source='ticket_number' label={label('ticket_number')} sortable={false} />
      <NumberField source='regular_time_in_hours' label={label('regular_time_in_hours')} options={numberFieldOptions} sortable={false} forceZero />
      <NumberField source='regular_rate_in_dollars' label={label('regular_rate_in_dollars')} options={currencyFieldOptions} sortable={false} />
      <NumberField source='overtime_in_hours' label={label('overtime_in_hours')} options={numberFieldOptions} sortable={false} forceZero />
      <NumberField source='overtime_rate_in_dollars' label={label('overtime_rate_in_dollars')} options={currencyFieldOptions} sortable={false} />
      <NumberField source='doubletime_in_hours' label={label('doubletime_in_hours')} options={numberFieldOptions} sortable={false} forceZero />
      <NumberField source='doubletime_rate_in_dollars' label={label('doubletime_rate_in_dollars')} options={currencyFieldOptions} sortable={false} />
      <NumberField source='total_in_dollars' label={label('total_in_dollars')} options={currencyFieldOptions} sortable={false} forceZero />
    </DatagridWithSubtotals>
  )
}

const Totals = ({ data }) => {
  const translate = useTranslateResource('hourly_ticket_invoices', 'labels.invoice')

  return (
    <DataTable data={data}>
      <NumberField source='total_line_item_quantity' label={translate('total_line_item_quantity')} />
      <NumberField source='total_in_dollars' label={translate('total_in_dollars')} options={currencyFieldOptions} />
    </DataTable>
  )
}

const HourlyInvoice = ({ record }) => {
  const translate = useTranslateResource('hourly_ticket_invoices', 'labels.invoice')

  const {
    customer,
    invoice_number,
    hourly_rate,
    total_in_dollars,
    total_line_item_quantity,
    tenant,
    hourly_tickets: tickets,
    period: { end_date: date },
  } = record

  const Detail = () => (
    <>
      <Typography align='right'>
        {translate('workType')}
      </Typography>
      {
        hourly_rate &&
        <Typography align='right'>
          {hourly_rate.description}
        </Typography>
      }
    </>
  )

  return (
    <Invoice
      customer={customer}
      tenant={tenant}
      invoiceNumber={invoice_number}
      date={date}
      detail={<Detail />}
      lineItems={<TicketsGrid tickets={tickets} />}
      totals={<Totals data={{ total_in_dollars, total_line_item_quantity }}/>}
    />
  )
}

export default HourlyInvoice
